/**
 * Provider Briefing Routes
 * legacy app: canActivate: [AuthGuard]
 */

import React, { lazy } from 'react';
import { RouteConfig, RouteMetadata } from '../../types';

const ProviderBriefing = lazy(() =>
  import('@src/apps/ProviderBriefing/ProviderBriefing').then(m => ({ default: m.ProviderBriefing }))
);

const ProviderBriefingDocument = lazy(() =>
  import('@src/apps/ProviderBriefing/ProviderBriefingDocument/ProviderBriefingDocument').then(m => ({ default: m.ProviderBriefingDocument }))
);

const EXTERNAL_ACCESS_DENIED: Pick<RouteMetadata, 'externalAccess'> = {
  externalAccess: false,
};

const providerBriefingRouteFrameStyles: React.CSSProperties = {
  width: '60rem',
  maxWidth: '100%',
  margin: '0 auto',
  boxSizing: 'border-box',
};

const ProviderBriefingRouteFrame: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div style={providerBriefingRouteFrameStyles}>{children}</div>
);

const ProviderBriefingRoute = () => (
  <ProviderBriefingRouteFrame>
    <ProviderBriefing />
  </ProviderBriefingRouteFrame>
);

const ProviderBriefingDocumentRoute = () => (
  <ProviderBriefingRouteFrame>
    <ProviderBriefingDocument />
  </ProviderBriefingRouteFrame>
);

export const providerBriefingRoutes: RouteConfig[] = [
  {
    path: 'provider-briefing/document',
    component: ProviderBriefingDocument,
    guards: ['auth'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'Provider Negotiation Briefing',
      breadcrumb: 'Provider Briefing Document',
      preload: false,
      delay: true,
    },
  },
  {
    path: 'provider-briefing/*',
    component: ProviderBriefingRoute,
    guards: ['auth'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'Provider Negotiation Briefing',
      breadcrumb: 'Provider Briefing',
      preload: false,
      delay: true,
    },
  },
  {
    path: 'provider-briefing/document',
    component: ProviderBriefingDocumentRoute,
    guards: ['auth'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'Provider Negotiation Briefing',
      breadcrumb: 'Provider Briefing Document',
      preload: false,
      delay: true,
    },
  },
];

